<template>
  <div v-loading.body="loading">
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item>
                  <el-input
                    v-model="form.shipping_num"
                    placeholder="快递单号"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.status"
                    placeholder="包裹状态"
                    filterable
                    style="width: 150px"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in searchOptions.status"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.user_id"
                    placeholder="用户id"
                  ></el-input>
                </el-form-item>
                <el-form-item label="仓库接收时间：">
                  <el-date-picker
                    v-model="form.receive_time"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['06:00:00', '06:00:00']"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="拆包开始时间：">
                  <el-date-picker
                    v-model="form.unpack_begin_time"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['06:00:00', '06:00:00']"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.is_broken"
                    placeholder="包裹接收是否破损"
                    style="width: 150px"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in searchOptions.is_broken_ops"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="拆包提交时间：">
                  <el-date-picker
                    v-model="form.unpack_submit_time"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['06:00:00', '06:00:00']"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="拆包结束时间：">
                  <el-date-picker
                    v-model="form.unpack_complete_time"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['06:00:00', '06:00:00']"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="" @click="reset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <el-button
            style="margin-left: auto"
            type="success"
            size="mini"
            @click="exportExcel"
            >导出收包列表</el-button
          >

          <el-button
            style="margin-left: 10px"
            type="success"
            size="mini"
            @click="exportExcelDetail"
            >导出收包明细</el-button
          >
          <el-date-picker
            v-show="export_da_biao_record_date_picker_show"
            v-model="export_da_biao_record_date"
            size="mini"
            type="datetimerange"
            range-separator="至"
            start-placeholder="打标开始日期"
            end-placeholder="打标结束日期"
            :default-time="['06:00:00', '06:00:00']"
          >
          </el-date-picker>
          <el-button
            style="margin-left: 10px"
            type="info"
            size="mini"
            @click="exportDeleteRecord"
            >导出删除记录</el-button
          >
          <el-date-picker
            v-show="export_delete_record_date_picker_show"
            v-model="export_delete_record_date"
            size="mini"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['06:00:00', '06:00:00']"
          >
          </el-date-picker>
        </div>
        <div v-if="resData.list" style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="shipping_num"
              label="快递单号"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="user_id"
              label="用户id"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="receive_time"
              label="仓库接收时间"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="receive_admin"
              label="接收人"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="receive_has_work"
              label="接收是否已绑定工单"
              width=""
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="receive_num"
              label="接收件数"
              width="150"
            ></el-table-column>
            <el-table-column align="center" label="接收图片">
              <template slot-scope="scope">
                <div
                  v-if="scope.row.receive_img"
                  style="width: 70px; height: 70px"
                >
                  <img
                    :src="scope.row.receive_img"
                    style="width: 100%; height: 100%"
                    @click="showImages([scope.row.receive_img])"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="as_package_package_status"
              label="包裹状态"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="unpack_begin_time"
              label="拆包开始时间"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="unpack_submit_time"
              label="拆包提交时间"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="unpack_complete_time"
              label="拆包完成时间"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="work_num"
              label="工单数量"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="goods_number"
              label="工单商品数量"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="unpack_num"
              label="拆包数量"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="normal_num"
              label="正常品"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="thh_num"
              label="退换货"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="cp_num"
              label="次品"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="no_data_goods_num"
              label="无数据"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="is_exception"
              label="是否异常"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="content"
              label="操作"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(scope.row)"
                  >详情</el-button
                >
                <el-button
                  v-if="scope.row.package_status == 3"
                  style="color: red"
                  type="text"
                  size="small"
                  @click="setOver(scope.row)"
                  >结束</el-button
                >
                <el-button
                  v-if="scope.row.package_status == 1"
                  type="text"
                  style="color: red"
                  size="small"
                  @click="remove(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="resData.count"
            :page-size="form.pagesize"
            :page-sizes="[50, 100, 200, 500, 1000]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <preview-image
      :imgs="images"
      :show="showbox"
      @closeBox="closeBox()"
    ></preview-image>
  </div>
</template>

<script>
import PreviewImage from "../../components/PreviewImage.vue";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  components: {
    PreviewImage,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchCondition();
    });
  },
  data() {
    return {
      images: [],
      showbox: false,
      fileList: [],
      resData: {},
      export_delete_record_date: [],
      export_delete_record_date_picker_show: false,
      export_da_biao_record_date: [],
      export_da_biao_record_date_picker_show: false,
      form: {
        pagesize: 50,
        receive_time: this.$excalibur.getDateTimeOnHours(1, 6),
      },
      loading: false,
      tableLoading: false,
      url: "/erp/AsPackage/getAsPackageList",
      curPage: 1,
      filterFold: false,
      searchOptions: {
        status: {},
      },
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    showImages(img) {
      this.showbox = true;
      this.images = img;
    },
    closeBox() {
      this.showbox = false;
    },
    exportExcel() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.form.is_excel = 0;
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },
    exportExcelDetail() {
      if (this.export_da_biao_record_date_picker_show) {
        this.form.out_detail = 1;
        this.form.da_biao_time = this.export_da_biao_record_date;
        this.$http.post(this.url, this.filteredForm).then((res) => {
          this.form.out_detail = 0;
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        });
      }
      this.export_da_biao_record_date_picker_show = true;
    },
    exportDeleteRecord() {
      if (this.export_delete_record_date_picker_show) {
        this.$http
          .post("/erp/AsPackage/exportDeleteRecord", {
            date: this.export_delete_record_date,
          })
          .then((res) => {
            if (res.data.code == 200) {
              window.open(apiBaseURL + res.data.data.file);
            } else {
              this.$message.e(res.data.msg);
            }
          });
      }
      this.export_delete_record_date_picker_show = true;
    },
    // 详情
    handleClick(row) {
      this.$router.push(
        `/home/aspackage/aspackagedetail?shipping_num=${row.shipping_num}`
      );
    },
    setOver(row) {
      this.$confirm(`确认结束?`, "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/AsPackage/overPackage", {
              as_package_id: row.as_package_id,
            })
            .then((rs) => {
              if (rs.data.code != 200) return this.$message.error(rs.data.msg);
              this.fetchData();
              this.$message.success(rs.data.msg);
            });
        })
        .catch(() => {});
    },
    remove(row) {
      this.$prompt("请输入删除包裹的原因", "提示", {
        inputType: "textarea",
        type: "warning",
        inputValidator(value) {
          if (value.length <= 0) {
            return "请输入具体原因";
          }
          return true;
        },
      }).then(({ value }) => {
        this.$http
          .post("/erp/AsPackage/removePackage", {
            as_package_id: row.as_package_id,
            reason: value,
          })
          .then((res) => {
            if (res.data.code == 200) {
              this.$message.success("删除成功");
              this.fetchData();
            } else {
              this.$message.e(res.data.msg);
            }
          });
      });
    },
    fetchCondition() {
      this.$http
        .post("/erp/AsPackage/getCondition", this.filteredForm)
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.searchOptions = res.data.data;
          }
        });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      this.multipleSelection = multipleSelection;
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          console.log(this.resData);
        }
      });
    },
    handleSizeChange(val) {
      this.form.pagesize = val;
      this.fetchData(true);
    },

    search() {
      this.form.page = 1;
      this.loading = true;
      this.fetchData(true);
    },

    trim(str, is_global) {
      let result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (is_global.toLowerCase() == "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
    reset() {
      this.form = {
        page: 1,
        pagesize: 50,
        receive_time: this.$excalibur.getDateTimeOnHours(1, 6),
      };
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1rpx solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/aspackage/AsPackageList.vue